import connect from 'utils/store/connect';

import { switchApplicationMode } from 'app/App/actions';
import applicationModeSelector from 'app/App/selectors/applicationMode';
import contractMapSelector from 'app/App/selectors/contractMap';
import pageTemplatesModeSelector from 'app/App/selectors/pageTemplatesMode';
import {
  canEditAtLeastOneComponentSelector,
  canEditFolderSelector,
  editableComponentsListSelector
} from 'app/Can/selectors';
import {
  isPageSelectedSelector,
  pageTemplateNameSelector,
  pageTypeSelector
} from 'app/Page/selectors';
import { visitFolder } from 'app/Router/actions';
import { clearSearch } from 'app/Search/actions';
import {
  addFilter,
  clearAllFilters,
  deleteFilter,
  getSearchResults,
  storeContext,
  storeResultPageNum
} from 'app/Search/thunks';
import cwdSiteRootSelector from 'app/Tree/selectors/cwdSiteRoot';

import showAddPageDialogSelector from './selectors/showAddPageDialog';
import showCreateMasterComponentDialogSelector from './selectors/showCreateMasterComponentDialog';
import makeFilters from './selectors/makeFilters';
import Explorer from './components/Explorer';
import { toggleAddPage, toggleCreateMasterComponent } from './actions';
import {
  addNewComponentToPageThunk,
  checkStatusAndDuplicatePageThunk,
  checkStatusAndRemoveActivePageThunk,
  checkStatusAndToggleAddPageThunk,
  checkStatusAndToggleCreateMasterComponentThunk,
  checkStatusAndVisitPageThunk,
  createNewUnsavedPage,
  moveContentThunk
} from './thunks';

const filtersSelector = makeFilters();

/**
 * maps redux state to component props
 * @param {object} state - the current state
 * @returns {object} properties of state to be mapped to this component's props
 */
const mapStateToProps = state => ({
  applicationMode: applicationModeSelector(state),
  canEditAtLeastOneComponent: canEditAtLeastOneComponentSelector(state),
  contractMap: contractMapSelector(state),
  cwdSiteRoot: cwdSiteRootSelector(state),
  editableComponentsList: editableComponentsListSelector(state),
  filters: filtersSelector(state),
  isPageMode: pageTemplatesModeSelector(state),
  isPageSelected: isPageSelectedSelector(state),
  isReadonlyFolder: !canEditFolderSelector(state),
  pageTemplateName: pageTemplateNameSelector(state),
  pageType: pageTypeSelector(state),
  showAddPageDialog: showAddPageDialogSelector(state),
  showCreateMasterComponentDialog: showCreateMasterComponentDialogSelector(state)
});

const mapDispatchToProps = {
  addFilter,
  addNewComponentToPage: addNewComponentToPageThunk,
  checkStatusAndDuplicatePage: checkStatusAndDuplicatePageThunk,
  checkStatusAndRemoveActivePage: checkStatusAndRemoveActivePageThunk,
  checkStatusAndToggleAddPage: checkStatusAndToggleAddPageThunk,
  checkStatusAndToggleCreateMasterComponent: checkStatusAndToggleCreateMasterComponentThunk,
  checkStatusAndVisitPage: checkStatusAndVisitPageThunk,
  clearAllFilters,
  clearSearch,
  createNewUnsavedPage,
  deleteFilter,
  getSearchResults,
  moveContent: moveContentThunk,
  storeContext,
  storeResultPageNum,
  switchApplicationMode,
  toggleAddPage,
  toggleCreateMasterComponent,
  visitFolder
};

export default connect(mapStateToProps, mapDispatchToProps)(Explorer);
